"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypographyStylesProvider = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var TypographyStylesProvider_styles_1 = __importDefault(require("./TypographyStylesProvider.styles"));
function TypographyStylesProvider(_a) {
    var className = _a.className, themeOverride = _a.themeOverride, others = __rest(_a, ["className", "themeOverride"]);
    var classes = TypographyStylesProvider_styles_1.default({ theme: theme_1.useMantineTheme(themeOverride) });
    return react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.innerHtml, className) }, others));
}
exports.TypographyStylesProvider = TypographyStylesProvider;
TypographyStylesProvider.displayName = '@mantine/core/TypographyStylesProvider';
